import React, { Component } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

export default class BECollectionSmart extends Component {
  static propTypes = {
    className: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    stroke: PropTypes.string,
    fill: PropTypes.string,
    svgProps: PropTypes.object
  };

  static defaultProps = {
    className: "",
    size: "inherit",
    stroke: "currentColor",
    fill: "currentColor",
    svgProps: {}
  };

  get defaultHeight() {
    return 64;
  }

  get defaultWidth() {
    return 64;
  }

  get size() {
    return this.props.size;
  }

  get width() {
    if (this.size === null || this.size === "inherit") return null;
    if (this.size === "default") return this.defaultWidth;
    return this.size;
  }

  get height() {
    if (this.size === null || this.size === "inherit") return null;
    if (this.size === "default") return this.defaultHeight;
    return this.size;
  }

  get viewBox() {
    return "0 0 64 64";
  }

  get classes() {
    const { className } = this.props;
    return classnames("manicon-svg", className);
  }

  get fill() {
    return this.props.fill;
  }

  get stroke() {
    return this.props.stroke;
  }

  render() {
    const baseSvgProps = {
      xmlns: "http://www.w3.org/2000/svg",
      className: this.classes,
      width: this.width,
      height: this.height,
      viewBox: this.viewBox,
      fill: this.fill
    };

    const svgProps = Object.assign(baseSvgProps, this.props.svgProps);

    return (
      <svg {...svgProps}>
        <path d="M32,48.5009 C29.318062,48.5009 27.1445,46.3242373 27.1445,43.6399 C27.1445,40.9555627 29.318062,38.7789 32,38.7789 C34.681938,38.7789 36.8555,40.9555627 36.8555,43.6399 C36.8555,46.3242373 34.681938,48.5009 32,48.5009 Z M32,46.5009 C33.5767297,46.5009 34.8555,45.2203056 34.8555,43.6399 C34.8555,42.0594945 33.5767297,40.7789 32,40.7789 C30.4232703,40.7789 29.1445,42.0594945 29.1445,43.6399 C29.1445,45.2203056 30.4232703,46.5009 32,46.5009 Z M42.0755947,44.836361 L45.1264494,46.6005585 L41.1231409,53.544388 L38.0795724,51.7845902 C38.0430811,51.8122283 38.0065271,51.839394 37.9695475,51.8663538 C37.3575707,52.3113997 36.6983486,52.6861472 36.0044,52.9840531 L36.0044,56.5038 L27.9956,56.5038 L27.9956,52.9798534 C27.2604981,52.6638054 26.565526,52.2615394 25.9253312,51.7815359 L22.8763346,53.5443743 L18.8731212,46.6004788 L21.923821,44.8367123 C21.8300426,44.0417736 21.8302399,43.2385328 21.9244087,42.443641 L18.8735631,40.6794487 L22.8767388,33.7356184 L25.9204175,35.4954164 C25.9568937,35.4677898 25.9934311,35.4406364 26.0303922,35.4136901 C26.6423637,34.9685782 27.3016103,34.5938005 27.9956,34.2959069 L27.9956,30.7761 L36.0044,30.7761 L36.0044,34.3000555 C36.7394717,34.6161018 37.4344137,35.0183629 38.0745789,35.4983583 L41.1235529,33.7355329 L45.1268912,40.6794141 L42.0761823,42.4431858 C42.169969,43.2381588 42.1697717,44.041435 42.0755947,44.836361 Z M39.8681211,45.8701746 L40.0012194,45.1725837 C40.1944903,44.1596183 40.1947624,43.1192688 40.0020215,42.1062024 L39.8693499,41.4088665 L42.3965088,39.947786 L40.3910471,36.4692671 L37.8643603,37.9301217 L37.3257497,37.4625515 C36.5479889,36.787374 35.6486419,36.2666596 34.6758702,35.9282936 L34.0044,35.6947314 L34.0044,32.7761 L29.9956,32.7761 L29.9956,35.6911883 L29.3238075,35.9246056 C28.567581,36.18736 27.8542397,36.5602061 27.2077093,37.0304533 C27.0486672,37.1464026 26.8887318,37.2767791 26.6729337,37.463506 L26.1344841,37.9294183 L23.6092612,36.4693816 L21.6038369,39.9479513 L24.1318753,41.4098233 L23.9987816,42.1074109 C23.805522,43.1203474 23.8052499,44.1606656 23.9979795,45.1737031 L24.1306465,45.8710356 L21.6034788,47.3321213 L23.6088654,50.8106257 L26.1355279,49.3497852 L26.6741366,49.8173366 C27.4519331,50.4925204 28.3513146,51.0132372 29.3241195,51.3516028 L29.9956,51.5851604 L29.9956,54.5038 L34.0044,54.5038 L34.0044,51.5888679 L34.676122,51.3554189 C35.4323715,51.0925933 36.1457491,50.7197283 36.7922907,50.2495467 C36.9513328,50.1335974 37.1112682,50.003221 37.3270663,49.8164941 L37.8655248,49.350574 L40.3906591,50.8106121 L42.3961506,47.3320415 L39.8681211,45.8701746 Z M9.99999997,46.657 L15.017,46.657 L15.017,48.657 L7.99999996,48.657 L7.99999996,19.547 L56,19.547 L56,48.657 L48.983,48.657 L48.983,46.657 L54,46.657 L54,21.547 L9.99999997,21.547 L9.99999997,46.657 Z M13.0112,15.5218 L13.0112,13.5218 L50.9888,13.5218 L50.9888,15.5218 L13.0112,15.5218 Z M17.0224,9.49629997 L17.0224,7.49629996 L46.9776,7.49629996 L46.9776,9.49629997 L17.0224,9.49629997 Z" />
      </svg>
    );
  }
}
